import { render } from "./content-header.vue?vue&type=template&id=13caa845&scoped=true"
import script from "./content-header.vue?vue&type=script&lang=js"
export * from "./content-header.vue?vue&type=script&lang=js"

import "./content-header.vue?vue&type=style&index=0&id=13caa845&lang=css"
import "./content-header.vue?vue&type=style&index=1&id=13caa845&scoped=true&lang=css"
import "./content-header.vue?vue&type=style&index=2&id=13caa845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13caa845"]])

export default __exports__